import styled from 'styled-components';

export const AssoContainer = styled.div`
    height: 800px; 
    display:flex; 
    flex-direction: column;
    justify-content: center;
    align-items: center; 

    @media screen and (max-width: 768px){
        height: 600px; 
    }

    @media screen and (max-width: 480px){
    }
`;

export const AssoH1 = styled.h1`
    font-size: 2.5rem; 
    margin-bottom: 20px; 

    @media screen and (max-width: 480px){
        font-size: 2rem; 
    }
`;

export const AssoPicture = styled.div`
    max-width: 1000px; 
    align-items: center; 

    @media screen and (max-width: 1000px){
    }

    @media screen and (max-width: 768px){
    }
`;

export const Img = styled.img`
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 70%;
`;

